/* Fresh Flower theme scripts — native Shopify Cart AJAX API */
(function () {
  var money = function (cents) {
    var format = window.FreshFlower && window.FreshFlower.moneyFormat;
    var amount = (cents / 100).toLocaleString(document.documentElement.lang === 'ar' ? 'ar-EG' : 'en-EG', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });
    if (format && format.indexOf('{{') > -1) {
      return format.replace(/\{\{\s*\w+\s*\}\}/, amount);
    }
    return amount;
  };

  var t = function (key) {
    return (window.FreshFlower && window.FreshFlower.strings && window.FreshFlower.strings[key]) || '';
  };

  var qs = function (sel, root) { return (root || document).querySelector(sel); };
  var qsa = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- Cart drawer ---------- */
  var drawer = qs('[data-cart-drawer]');
  var overlay = qs('[data-cart-overlay]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function renderCart(cart) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });
    var body = qs('[data-cart-body]');
    var foot = qs('[data-cart-foot]');
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="cart-empty"><div><p>' + t('cartEmpty') + '</p></div></div>';
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;
    body.innerHTML = cart.items.map(function (item) {
      var image = item.image ? item.image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_200x$1$2') : '';
      return '<div class="cart-line" data-line-key="' + item.key + '">' +
        (image ? '<img src="' + image + '" alt="" loading="lazy">' : '<span></span>') +
        '<div><p class="cart-line-title">' + item.product_title + '</p>' +
        (item.variant_title && item.variant_title !== 'Default Title' ? '<p class="cart-line-price">' + item.variant_title + '</p>' : '') +
        '<p class="cart-line-price">' + money(item.final_price) + '</p>' +
        '<div class="qty-picker"><button type="button" aria-label="-" data-line-change="' + (item.quantity - 1) + '">&minus;</button>' +
        '<span>' + item.quantity + '</span>' +
        '<button type="button" aria-label="+" data-line-change="' + (item.quantity + 1) + '">+</button></div></div>' +
        '<button type="button" class="icon-button" data-line-remove aria-label="' + t('remove') + '">&times;</button>' +
        '</div>';
    }).join('');
    var totalEl = qs('[data-cart-total]');
    if (totalEl) totalEl.textContent = money(cart.total_price);
  }

  function fetchCart() {
    return fetch(window.Shopify.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function changeLine(key, quantity) {
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  document.addEventListener('click', function (event) {
    var openBtn = event.target.closest('[data-cart-open]');
    if (openBtn) { event.preventDefault(); fetchCart(); openDrawer(); return; }
    if (event.target.closest('[data-cart-close]')) { event.preventDefault(); closeDrawer(); return; }

    var change = event.target.closest('[data-line-change]');
    if (change) {
      var line = change.closest('[data-line-key]');
      changeLine(line.getAttribute('data-line-key'), parseInt(change.getAttribute('data-line-change'), 10));
      return;
    }
    var remove = event.target.closest('[data-line-remove]');
    if (remove) {
      var rline = remove.closest('[data-line-key]');
      changeLine(rline.getAttribute('data-line-key'), 0);
      return;
    }

    var toggle = event.target.closest('[data-menu-toggle]');
    if (toggle) { var nav = qs('[data-header-nav]'); if (nav) nav.classList.toggle('is-open'); return; }

    var searchToggle = event.target.closest('[data-search-toggle]');
    if (searchToggle) {
      var panel = qs('[data-search-panel]');
      if (panel) { panel.hidden = !panel.hidden; if (!panel.hidden) { var input = qs('input[name="q"]', panel); if (input) input.focus(); } }
      return;
    }
    if (event.target.closest('[data-search-close]')) { var p2 = qs('[data-search-panel]'); if (p2) p2.hidden = true; return; }

    var facetToggle = event.target.closest('[data-facet-toggle]');
    if (facetToggle) { var facets = qs('[data-facets]'); if (facets) facets.hidden = !facets.hidden; return; }
  });

  document.addEventListener('keydown', function (event) { if (event.key === 'Escape') closeDrawer(); });

  /* ---------- Quantity pickers ---------- */
  document.addEventListener('click', function (event) {
    var step = event.target.closest('[data-qty-step]');
    if (!step) return;
    var input = qs('input[name="quantity"]', step.closest('.qty-picker'));
    if (!input) return;
    var next = parseInt(input.value || '1', 10) + parseInt(step.getAttribute('data-qty-step'), 10);
    input.value = Math.max(1, next);
  });

  /* ---------- Add to cart (product form + product cards) ---------- */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-product-form]');
    if (!form) return;
    event.preventDefault();
    var button = qs('[type="submit"]', form);
    if (button) button.disabled = true;
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function () { openDrawer(); })
      .catch(function () { form.submit(); })
      .finally(function () { if (button) button.disabled = false; });
  });

  /* ---------- Variant selection ---------- */
  qsa('[data-variant-selector]').forEach(function (wrapper) {
    var data = JSON.parse(qs('[data-variant-json]', wrapper).textContent);
    var selects = qsa('select[data-option-index]', wrapper);
    var idInput = qs('input[name="id"]', wrapper.closest('form'));
    var priceEl = qs('[data-product-price]');
    var submit = qs('[type="submit"]', wrapper.closest('form'));
    selects.forEach(function (select) {
      select.addEventListener('change', function () {
        var chosen = selects.map(function (s) { return s.value; });
        var match = data.find(function (variant) {
          return variant.options.every(function (option, index) { return option === chosen[index]; });
        });
        if (!match) return;
        idInput.value = match.id;
        if (priceEl) priceEl.textContent = money(match.price);
        if (submit) {
          submit.disabled = !match.available;
          submit.textContent = match.available ? t('addToBag') : t('soldOut');
        }
      });
    });
  });

  /* ---------- Predictive search ---------- */
  var searchInput = qs('[data-search-panel] input[name="q"]');
  if (searchInput) {
    var timer;
    searchInput.addEventListener('input', function () {
      clearTimeout(timer);
      var value = searchInput.value.trim();
      var results = qs('[data-search-results]');
      if (!results) return;
      if (value.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch(window.Shopify.routes.root + 'search/suggest.json?q=' + encodeURIComponent(value) + '&resources[type]=product&resources[limit]=5')
          .then(function (r) { return r.json(); })
          .then(function (json) {
            var products = (json.resources.results.products || []);
            results.innerHTML = products.map(function (product) {
              return '<a href="' + product.url + '">' +
                (product.featured_image && product.featured_image.url ? '<img src="' + product.featured_image.url + '" alt="">' : '') +
                '<span>' + product.title + '</span></a>';
            }).join('');
          });
      }, 220);
    });
  }

  /* ---------- Sorting + filters auto submit ---------- */
  qsa('[data-auto-submit]').forEach(function (el) {
    el.addEventListener('change', function () { el.closest('form').submit(); });
  });

  /* ---------- Wishlist (local only UI) ---------- */
  var WISHLIST_KEY = 'fresh-flower-wishlist';
  function wishlist() { try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); } catch (e) { return []; } }
  function paintWishlist() {
    var saved = wishlist();
    qsa('[data-wishlist]').forEach(function (button) {
      button.classList.toggle('is-active', saved.indexOf(button.getAttribute('data-wishlist')) > -1);
      button.setAttribute('aria-pressed', saved.indexOf(button.getAttribute('data-wishlist')) > -1);
    });
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-wishlist]');
    if (!button) return;
    event.preventDefault();
    var handle = button.getAttribute('data-wishlist');
    var saved = wishlist();
    var index = saved.indexOf(handle);
    if (index > -1) saved.splice(index, 1); else saved.push(handle);
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(saved));
    paintWishlist();
  });
  paintWishlist();

  fetchCart();
})();
